import React from 'react';
import styles from '../../styles/common/pil.module.scss';

const PIL_TYPES = {
    info: 'info',
    success: 'success',
    warning: 'warning',
    error: 'error',
    loading: 'loading',
    disabled: 'disabled',
};

const PILComponent = ({
    label,
    type = 'info',
    size = 'small',
}) => {
    const isLoading = type === 'loading';
    const sizeClass = size === 'medium' ? styles.medium : '';
    
    return (
        <span className={`${styles.pilContainer} ${styles[PIL_TYPES[type]]} ${sizeClass}`}> 
            {isLoading && <span className={styles.loadingSpinner}></span>}
            <p>{label}</p>
        </span>
    );
};

export default PILComponent;